import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SkeletonModule } from "primeng/skeleton";

@Component({
  selector: "app-dashboard-container-skeleton",
  imports: [CommonModule, SkeletonModule],
  templateUrl: "./dashboard-container-skeleton.component.html",
  styleUrl: "./dashboard-container-skeleton.component.scss",
})
export class DashboardContainerSkeletonComponent {
  // No properties needed - skeleton structure is static in template
}
